/* Google Maps API - BEGIN */
// prettier-ignore
(g => { var h, a, k, p = "The Google Maps JavaScript API", c = "google", l = "importLibrary", q = "__ib__", m = document, b = window; b = b[c] || (b[c] = {}); var d = b.maps || (b.maps = {}), r = new Set, e = new URLSearchParams, u = () => h || (h = new Promise(async (f, n) => { await (a = m.createElement("script")); e.set("libraries", [...r] + ""); for (k in g) e.set(k.replace(/[A-Z]/g, t => "_" + t[0].toLowerCase()), g[k]); e.set("callback", c + ".maps." + q); a.src = `https://maps.${c}apis.com/maps/api/js?` + e; d[q] = f; a.onerror = () => h = n(Error(p + " could not load.")); a.nonce = m.querySelector("script[nonce]")?.nonce || ""; m.head.append(a) })); d[l] ? console.warn(p + " only loads once. Ignoring:", g) : d[l] = (f, ...n) => r.add(f) && u().then(() => d[l](f, ...n)) })({
	key: "AIzaSyBI6tPwa8MKACCleug8ovZzNA6cwwdUS0E",
	v: "quarterly",
	// Use the 'v' parameter to indicate the version to use (weekly, beta, alpha, etc.).
	// Add other bootstrap parameters as needed, using camel case.
});
/* Google Maps API - END */

/*
OverlappingMarkerSpiderfier - BEGIN
https://github.com/jawj/OverlappingMarkerSpiderfier
Fork by https://github.com/copiri-six/AME_Spiderfier
Copyright (c) 2011 - 2017 George MacKerron
Released under the MIT licence: http://opensource.org/licenses/mit-license
Note: The Google Maps API v3 must be included *before* this code
*/
// prettier-ignore
var callbackName,callbackRegEx,ref,ref1,scriptTag,tag,hasProp={}.hasOwnProperty;this.OverlappingMarkerSpiderfier=(function(){var t,r,e,i,s,n,a,o,l,h;for(i=0,a=(t=class{constructor(t,i={}){var s,o,h,u;for(s in this.map=t,null==this.constructor.hasInitialized&&(this.constructor.hasInitialized=!0,r=(e=google.maps).event,n=e.MapTypeId,a.keepSpiderfied=!1,a.ignoreMapClick=!1,a.markersWontHide=!1,a.markersWontMove=!1,a.basicFormatEvents=!1,a.nearbyDistance=20,a.circleSpiralSwitchover=9,a.circleFootSeparation=23,a.circleStartAngle=l/12,a.spiralFootSeparation=26,a.spiralLengthStart=11,a.spiralLengthFactor=4,a.spiderfiedZIndex=e.Marker.MAX_ZINDEX+2e4,a.highlightedLegZIndex=e.Marker.MAX_ZINDEX+1e4,a.usualLegZIndex=e.Marker.MAX_ZINDEX+1,a.legWeight=1.5,a.legColors={usual:{},highlighted:{}},h=a.legColors.usual,o=a.legColors.highlighted,h[n.HYBRID]=h[n.SATELLITE]="#fff",o[n.HYBRID]=o[n.SATELLITE]="#f00",h[n.TERRAIN]=h[n.ROADMAP]="#444",o[n.TERRAIN]=o[n.ROADMAP]="#f00",this.constructor.ProjHelper=function(t){return this.setMap(t)},this.constructor.ProjHelper.prototype=new e.OverlayView,this.constructor.ProjHelper.prototype.draw=function(){}),i)hasProp.call(i,s)&&(u=i[s],this[s]=u);this.projHelper=new this.constructor.ProjHelper(this.map),this.initMarkerArrays(),this.listeners={},this.formatIdleListener=this.formatTimeoutId=null,this.addListener("click",function(t,e){return r.trigger(t,"spider_click",e)}),this.addListener("format",function(t,e){return r.trigger(t,"spider_format",e)}),this.ignoreMapClick||r.addListener(this.map,"click",()=>this.unspiderfy()),r.addListener(this.map,"maptypeid_changed",()=>this.unspiderfy()),r.addListener(this.map,"zoom_changed",()=>{if(this.unspiderfy(),!this.basicFormatEvents)return this.formatMarkers()})}}).prototype,s=(o=[t,a]).length;i<s;i++)(h=o[i]).VERSION="1.0.3";return l=2*Math.PI,e=r=n=null,t.markerStatus={SPIDERFIED:"SPIDERFIED",SPIDERFIABLE:"SPIDERFIABLE",UNSPIDERFIABLE:"UNSPIDERFIABLE",UNSPIDERFIED:"UNSPIDERFIED"},a.initMarkerArrays=function(){return this.markers=[],this.markerListenerRefs=[]},a.isVisibleMarker=function(t){return null!==t.map&&t.map.getBounds().contains(t.position)},a.addMarker=function(t,r){return t.setMap(this.map),this.trackMarker(t,r)},a.trackMarker=function(t,e){var i;return null!=t._oms||(t._oms=!0,i=[r.addListener(t,"click",r=>this.spiderListener(t,r))],this.markersWontHide||i.push(r.addListener(t,"visible_changed",()=>this.markerChangeListener(t,!1))),this.markersWontMove||i.push(r.addListener(t,"position_changed",()=>this.markerChangeListener(t,!0))),null!=e&&i.push(r.addListener(t,"spider_click",e)),this.markerListenerRefs.push(i),this.markers.push(t),this.basicFormatEvents?this.trigger("format",t,this.constructor.markerStatus.UNSPIDERFIED):(this.trigger("format",t,this.constructor.markerStatus.UNSPIDERFIABLE),this.formatMarkers())),this},a.markerChangeListener=function(t,r){if(!this.spiderfying&&!this.unspiderfying)return null!=t._omsData&&(r||!this.isVisibleMarker(t))&&this.unspiderfy(r?t:null),this.formatMarkers()},a.getMarkers=function(){return this.markers.slice(0)},a.removeMarker=function(t){return this.forgetMarker(t),t.setMap(null)},a.forgetMarker=function(t){var e,i,s,n,a;if(null!=t._omsData&&this.unspiderfy(),(e=this.arrIndexOf(this.markers,t))<0)return this;for(i=0,s=(a=this.markerListenerRefs.splice(e,1)[0]).length;i<s;i++)n=a[i],r.removeListener(n);return delete t._oms,this.markers.splice(e,1),this.formatMarkers(),this},a.removeAllMarkers=a.clearMarkers=function(){var t,r,e,i;for(i=this.getMarkers(),this.forgetAllMarkers(),t=0,r=i.length;t<r;t++)(e=i[t]).setMap(null);return this},a.forgetAllMarkers=function(){var t,e,i,s,n,a,o,l,h;for(this.unspiderfy(),h=this.markers,t=e=0,i=h.length;e<i;t=++e){for(l=0,o=h[t],s=(a=this.markerListenerRefs[t]).length;l<s;l++)n=a[l],r.removeListener(n);delete o._oms}return this.initMarkerArrays(),this},a.addListener=function(t,r){var e;return(null!=(e=this.listeners)[t]?e[t]:e[t]=[]).push(r),this},a.removeListener=function(t,r){var e;return(e=this.arrIndexOf(this.listeners[t],r))<0||this.listeners[t].splice(e,1),this},a.clearListeners=function(t){return this.listeners[t]=[],this},a.trigger=function(t,...r){var e,i,s,n,a,o;for(i=0,a=null!=(n=this.listeners[t])?n:[],o=[],s=a.length;i<s;i++)e=a[i],o.push(e(...r));return o},a.generatePtsCircle=function(t,r){var i,s,n,a,o,h,u,p;for(h=(n=this.circleFootSeparation*(2+t))/l,s=l/t,p=[],a=o=0,u=t;0<=u?o<u:o>u;a=0<=u?++o:--o)i=this.circleStartAngle+a*s,p.push(new e.Point(r.x+h*Math.cos(i),r.y+h*Math.sin(i)));return p},a.generatePtsSpiral=function(t,r){var i,s,n,a,o,h,u;for(a=this.spiralLengthStart,i=0,u=[],s=n=0,h=t;0<=h?n<h:n>h;s=0<=h?++n:--n)i+=this.spiralFootSeparation/a+5e-4*s,o=new e.Point(r.x+a*Math.cos(i),r.y+a*Math.sin(i)),a+=l*this.spiralLengthFactor/i,u.push(o);return u},a.spiderListener=function(t,r){var e,i,s,n,a,o,l,h,u,p,c;if((o=null!=t._omsData)&&this.keepSpiderfied||this.unspiderfy(),o||this.map.getStreetView().getVisible()||"GoogleEarthAPI"===this.map.getMapTypeId())return this.trigger("click",t,r);for(e=0,h=[],u=[],p=(l=this.nearbyDistance)*l,a=this.llToPt(t.position),i=(c=this.markers).length;e<i;e++)null!=(s=c[e]).map&&this.isVisibleMarker(s)&&(n=this.llToPt(s.position),this.ptDistanceSq(n,a)<p?h.push({marker:s,markerPt:n}):u.push(s));return 1===h.length?this.trigger("click",t,r):this.spiderfy(h,u)},a.markersNearMarker=function(t,r=!1){var e,i,s,n,a,o,l,h,u,p,c;if(null==this.projHelper.getProjection())throw"Must wait for 'idle' event on map before calling markersNearMarker";for(e=0,h=(l=this.nearbyDistance)*l,a=this.llToPt(t.position),o=[],i=(u=this.markers).length;e<i&&!((s=u[e])!==t&&null!=s.map&&this.isVisibleMarker(s)&&(n=this.llToPt(null!=(p=null!=(c=s._omsData)?c.usualPosition:void 0)?p:s.position),this.ptDistanceSq(n,a)<h&&(o.push(s),r)));e++);return o},a.markerProximityData=function(){var t,r,e,i,s,n,a,o,l,h,u,p,c,g,f,m;if(null==this.projHelper.getProjection())throw"Must wait for 'idle' event on map before calling markersNearAnyOtherMarker";for(g=(c=this.nearbyDistance)*c,u=(function(){var t,r,e,i,s,a;for(t=0,e=this.markers,a=[],r=e.length;t<r;t++)n=e[t],a.push({pt:this.llToPt(null!=(i=null!=(s=n._omsData)?s.usualPosition:void 0)?i:n.position),willSpiderfy:!1});return a}).call(this),f=this.markers,t=e=0,i=f.length;e<i;t=++e)if(null!=(a=f[t]).map&&this.isVisibleMarker(a)&&!(o=u[t]).willSpiderfy)for(m=this.markers,r=p=0,s=m.length;p<s;r=++p){if(l=m[r],r!==t&&null!=l.map&&this.isVisibleMarker(l)){if(h=u[r],(!(r<t)||h.willSpiderfy)&&this.ptDistanceSq(o.pt,h.pt)<g){o.willSpiderfy=h.willSpiderfy=!0;break}}}return u},a.markersNearAnyOtherMarker=function(){var t,r,e,i,s,n,a;for(s=this.markerProximityData(),n=this.markers,a=[],t=r=0,e=n.length;r<e;t=++r)i=n[t],s[t].willSpiderfy&&a.push(i);return a},a.setImmediate=function(t){return window.setTimeout(t,0)},a.formatMarkers=function(){if(!this.basicFormatEvents&&null==this.formatTimeoutId)return this.formatTimeoutId=this.setImmediate(()=>(this.formatTimeoutId=null,null!=this.projHelper.getProjection())?this._formatMarkers():null==this.formatIdleListener?this.formatIdleListener=r.addListenerOnce(this.map,"idle",()=>this._formatMarkers()):void 0)},a._formatMarkers=function(){var t,r,e,i,s,n,a,o,l,h,u;if(this.basicFormatEvents){for(r=0,l=[],e=markers.length;r<e;r++)u=null!=(s=markers[r])._omsData?"SPIDERFIED":"UNSPIDERFIED",l.push(this.trigger("format",s,this.constructor.markerStatus[u]));return l}for(a=this.markerProximityData(),o=this.markers,h=[],t=n=0,i=o.length;n<i;t=++n)u=null!=(s=o[t])._omsData?"SPIDERFIED":a[t].willSpiderfy?"SPIDERFIABLE":"UNSPIDERFIABLE",h.push(this.trigger("format",s,this.constructor.markerStatus[u]));return h},a.makeHighlightListenerFuncs=function(t){return{highlight:()=>t._omsData.leg.setOptions({strokeColor:this.legColors.highlighted[this.map.mapTypeId],zIndex:this.highlightedLegZIndex}),unhighlight:()=>t._omsData.leg.setOptions({strokeColor:this.legColors.usual[this.map.mapTypeId],zIndex:this.usualLegZIndex})}},a.spiderfy=function(t,i){var s,n,a,o,l,h,u,p,c,g,f;return this.spiderfying=!0,g=t.length,s=this.ptAverage(function(){var r,e,i;for(r=0,i=[],e=t.length;r<e;r++)p=t[r],i.push(p.markerPt);return i}()),o=g>=this.circleSpiralSwitchover?this.generatePtsSpiral(g,s).reverse():this.generatePtsCircle(g,s),f=(function(){var i,s,p;for(i=0,p=[],s=o.length;i<s;i++)a=o[i],n=this.ptToLl(a),u=(c=this.minExtract(t,t=>this.ptDistanceSq(t.markerPt,a))).marker,h=new e.Polyline({map:this.map,path:[u.position,n],strokeColor:this.legColors.usual[this.map.mapTypeId],strokeWeight:this.legWeight,zIndex:this.usualLegZIndex}),u._omsData={usualPosition:u.position,usualZIndex:u.zIndex,leg:h},this.legColors.highlighted[this.map.mapTypeId]!==this.legColors.usual[this.map.mapTypeId]&&(l=this.makeHighlightListenerFuncs(u),u._omsData.hightlightListeners={highlight:r.addListener(u,"mouseover",l.highlight),unhighlight:r.addListener(u,"mouseout",l.unhighlight)}),this.trigger("format",u,this.constructor.markerStatus.SPIDERFIED),u.position=n,u.zIndex=Math.round(this.spiderfiedZIndex+a.y),p.push(u);return p}).call(this),delete this.spiderfying,this.spiderfied=!0,this.trigger("spiderfy",f,i)},a.unspiderfy=function(t=null){var e,i,s,n,a,o,l,h;if(null==this.spiderfied)return this;for(e=0,this.unspiderfying=!0,h=[],a=[],i=(o=this.markers).length;e<i;e++)null!=(n=o[e])._omsData?(n._omsData.leg.setMap(null),n!==t&&(n.position=n._omsData.usualPosition),n.zIndex=n._omsData.usualZIndex,null!=(s=n._omsData.hightlightListeners)&&(r.removeListener(s.highlight),r.removeListener(s.unhighlight)),delete n._omsData,n!==t&&(l=this.basicFormatEvents?"UNSPIDERFIED":"SPIDERFIABLE",this.trigger("format",n,this.constructor.markerStatus[l])),h.push(n)):a.push(n);return delete this.unspiderfying,delete this.spiderfied,this.trigger("unspiderfy",h,a),this},a.ptDistanceSq=function(t,r){var e,i;return(e=t.x-r.x)*e+(i=t.y-r.y)*i},a.ptAverage=function(t){var r,i,s,n,a,o;for(r=0,a=o=0,i=t.length;r<i;r++)a+=(n=t[r]).x,o+=n.y;return s=t.length,new e.Point(a/s,o/s)},a.llToPt=function(t){return this.projHelper.getProjection().fromLatLngToDivPixel(t)},a.ptToLl=function(t){return this.projHelper.getProjection().fromDivPixelToLatLng(t)},a.minExtract=function(t,r){var e,i,s,n,a,o,l;for(s=a=0,o=t.length;a<o;s=++a)l=r(n=t[s]),(null==e||l<i)&&(i=l,e=s);return t.splice(e,1)[0]},a.arrIndexOf=function(t,r){return null!=t.indexOf?t.indexOf(r):-1},t}).call(this),callbackRegEx=/(\?.*(&|&amp;)|\?)spiderfier_callback=(\w+)/,null==(scriptTag=document.currentScript)&&(scriptTag=function(){var t,r,e,i,s;for(t=0,e=document.getElementsByTagName("script"),s=[],r=e.length;t<r;t++)(null!=(i=(tag=e[t]).getAttribute("src"))?i.match(callbackRegEx):void 0)&&s.push(tag);return s}()[0]),null!=scriptTag&&(callbackName=null!=(ref=scriptTag.getAttribute("src"))&&null!=(ref1=ref.match(callbackRegEx))?ref1[3]:void 0)&&"function"==typeof window[callbackName]&&window[callbackName](),"function"==typeof window.spiderfier_callback&&window.spiderfier_callback();
/* OverlappingMarkerSpiderfier - END */

class StoreLocations extends HTMLElement {
    constructor() {
        super();
        this.dataset.loading = true;

        // Get base URL.
        this.basePath = this.dataset.basePath || "/pages/locations";
        this.documentTitle = document.title;

        // Get search form.
        this.searching = false;
        this.formSearch = this.querySelector("form[data-search]");
        this.searchInput = this.formSearch.querySelector('[name="search_locations"]');
        this.buttonSearch = this.formSearch.querySelector('[type="submit"]');
        this.feedback = this.formSearch.querySelector('[name="_feedback"]');

        // Get filters.
        this.filters = {
            quarks: this.formSearch.querySelector('[name="checkbox_quarks"]'),
            urbanTrail: this.formSearch.querySelector('[name="checkbox_urbantrail"]')
        };

        // Get my location button.
        this.buttonMyLocation = this.querySelector("button[data-my-location]");
        this.mapPosition = {};
        if (!navigator.geolocation) this.buttonMyLocation.remove();

        // Get map container.
        this.mapContainer = this.querySelector("[data-map]");

        // Setup Canada bounds.
        this.latLngBounds = {
            north: 70,
            south: 40,
            east: -53,
            west: -141
        };
        this.centreLatLng = {
            lat: 56,
            lng: -106
        };
        this.defaultZoom = 3;
        this.defaultZoomedIn = 10;

        // Setup province names.
        this.provinces = {
            AB: "Alberta",
            BC: "British Columbia",
            MB: "Manitoba",
            NB: "New Brunswick",
            NL: "Newfoundland and Labrador",
            NS: "Nova Scotia",
            NT: "Northwest Territories",
            NU: "Nunavut",
            ON: "Ontario",
            PEI: "Prince Edward Island",
            QC: "Quebec",
            SK: "Saskatchewan",
            YT: "Yukon"
        };

        // Setup store list.
        this.list = {
            groupByProv: true,
            section: this.querySelector('[data-location-list="section"]'),
            template: {
                heading: this.querySelector('[data-location-list="template-heading"]'),
                list: this.querySelector('[data-location-list="template-list"]'),
                item: this.querySelector('[data-location-list="template-item"]')
            }
        };

        // Setup store details.
        this.stores = [];
        this.details = {
            section: this.querySelector('[data-location-detail="section"]'),
            buttonClose: this.querySelector('[data-location-detail="close"]'),
            buttonDirections: this.querySelector('[data-location-detail="buttonDirections"]'),
            buttonPhone: this.querySelector('[data-location-detail="buttonPhone"]'),
            name: this.querySelector('[data-location-detail="name"]'),
            distance: this.querySelector('[data-location-detail="distance"]'),
            address: this.querySelector('[data-location-detail="address"]'),
            phone: this.querySelector('[data-location-detail="phone"]'),
            storeNotes: this.querySelector('[data-location-detail="storeNotes"]'),
            hours: this.querySelector('[data-location-detail="hours"]'),
            nearby: this.querySelector('[data-location-detail="nearby"]'),
            nearbyName: this.querySelector('[data-location-detail="nearby-name"]')
        };
        this.details.buttonClose.addEventListener("click", this.selectStore.bind(this, false));
        this.selectedStore = false;

        this.getStoreLocations();
    }

    haversineCalculation(point1, point2, radius = 6367.5) {
        if (point1.lat) point1.latitude = point1.lat;
        if (point1.lng) point1.longitude = point1.lng;
        if (point2.lat) point2.latitude = point2.lat;
        if (point2.lng) point2.longitude = point2.lng;

        /**
         * @param {number} angle
         */
        function haversine(angle) {
            return 0.5 - Math.cos(angle) / 2;
        }

        /**
         * @param {number} degrees
         */
        function degreesToRadians(degrees) {
            return degrees * (Math.PI / 180);
        }

        return (2 * radius * Math.asin(Math.sqrt(haversine(degreesToRadians(point2.latitude - point1.latitude)) + Math.cos(degreesToRadians(point1.latitude)) * Math.cos(degreesToRadians(point2.latitude)) * haversine(degreesToRadians(point2.longitude - point1.longitude))))).toFixed(1);
    }

    showError(e) {
        this.innerHTML = `<p>Something went wrong while trying to get the store locations. Please refresh this page to try again.</p>`;
        console.error(e);
    }

    async getStoreLocations() {
        try {
            // Get store locations.
            const ncolApiUrlLocations = `${ncol_api_url}/public/api/locations.json`;
            const fetchRes = await fetch(ncol_locations_json_url || ncolApiUrlLocations, { cache: 'no-cache' });
            const data = await fetchRes.json();
            this.stores = data.stores;
        } catch (e) {
            this.showError(e);
        }

        this.stores.forEach(function (store) {
            if (store.name.includes("Quarks")) store.brand = "Quarks";
            else if (store.name.includes("Urban Trail")) store.brand = "Urban Trail";
            store.shortName = store.name.replace(/(Quarks|Urban Trail) - /, "");

            store.nearby.forEach(function (nearby) {
                if (nearby.name.includes("Quarks")) nearby.brand = "Quarks";
                else if (nearby.name.includes("Urban Trail")) nearby.brand = "Urban Trail";
            });

            const listItem = this.list.template.item.content.cloneNode(true);
            const link = listItem.querySelector('[data-location-list="link"]');
            link.href = `${this.basePath}/${store.handle}`;
            listItem.querySelector('[data-location-list="brand"]').dataset.brand = store.brand;
            listItem.querySelector('[data-location-list="brand"]').textContent = store.brand;
            listItem.querySelector('[data-location-list="name"]').textContent = store.shortName;
            listItem.querySelector('[data-location-list="address"]').textContent = `${store.address1}, ${store.city}, ${store.province_code}`;

            const storeMap = this;
            link.addEventListener("click", (event) => {
                event.preventDefault();
                storeMap.selectStore(store);
            });

            store.listItem = listItem.children[0];
        }, this);

        // Show store list.
        this.showList(true);

        try {
            await this.initMap();
            this.removeAttribute("data-loading");
        } catch (e) {
            this.showError(e);
        }
    }

    showList() {
        this.list.section.innerHTML = "";

        if (!this.list.groupByProv) {
            const list = this.list.template.list.content.cloneNode(true).children[0];

            const heading = this.list.template.heading.content.cloneNode(true).children[0];
            heading.textContent = "Closest Stores";
            this.list.section.appendChild(heading);

            // Sort stores by distance.
            const sortedStores = this.stores.toSorted(function (a, b) {
                return a.distanceToLocation - b.distanceToLocation;
            });
            sortedStores.forEach(function (store) {
                if (store.hidden) return;
                list.appendChild(store.listItem);
            }, this);
            this.list.section.appendChild(list);
            return;
        }

        const availableProvinces = {};
        this.stores.forEach(function (store) {
            if (store.hidden) return;
            if (!availableProvinces[store.province_code]) availableProvinces[store.province_code] = [];
            availableProvinces[store.province_code].push(store.listItem);
        });

        for (const code in this.provinces) {
            if (!availableProvinces[code]) continue;
            const province = availableProvinces[code];
            const list = this.list.template.list.content.cloneNode(true).children[0];
            const heading = this.list.template.heading.content.cloneNode(true).children[0];
            heading.textContent = this.provinces[code];
            this.list.section.appendChild(heading);
            province.forEach(function (store) {
                list.appendChild(store);
            });
            this.list.section.appendChild(list);
        }
    }

    async initMap() {
        // Get maps.
        const { AdvancedMarkerElement, PinElement } = await google.maps.importLibrary("marker");
        const { Map } = await google.maps.importLibrary("maps");
        const { spherical } = await google.maps.importLibrary("geometry");
        this.googleMaps = {
            AdvancedMarkerElement,
            PinElement,
            Map,
            spherical
        };

        this.map = new Map(this.mapContainer, {
            center: this.centreLatLng,
            zoom: this.defaultZoom,
            mapId: "ec2e14b423e5450d",
            disableDefaultUI: true,
            scaleControl: true,
            cameraControl: true,
            gestureHandling: "greedy",
            restriction: {
                latLngBounds: this.latLngBounds
            }
        });

        // Setup Overlapping Marker Spiderfier (OMBS)
        // https://github.com/jawj/OverlappingMarkerSpiderfier
        this.mapOms = new OverlappingMarkerSpiderfier(this.map, {
            markersWontMove: true,
            markersWontHide: true,
            basicFormatEvents: true
        });

        // Insert markers.
        this.stores.forEach(function (store) {
            this.initStoreMarker(store);
        }, this);

        // Setup current location button.
        this.buttonMyLocation.addEventListener("click", this.useMyLocation.bind(this));

        // Setup history tracking.
        window.addEventListener("popstate", this.locationInPath.bind(this));
        this.locationInPath();

        this.initSearch();
        this.initFilters();
    }

    locationInPath() {
        const path = window.location.pathname;
        const storeHandle = path.replace(/\/$/, "").split("/").pop();
        if (!storeHandle) return this.selectStore(false);

        // If handle ends with "quarks" or "urban-trail", select the type instead.
        if (storeHandle === "quarks" || storeHandle === "urban-trail") {
            this.filters[storeHandle === "quarks" ? "quarks" : "urbanTrail"].checked = true;
            this.filterStores();
            this.selectStore(false);
            return;
        }

        const store = this.stores.find((store) => store.handle === storeHandle);
        this.selectStore(store || false);
    }

    setSearching(isSearching, type) {
        this.searching = isSearching;
        this.searchInput.disabled = isSearching;
        this.buttonSearch.disabled = isSearching;
        this.buttonMyLocation.disabled = isSearching;
        this.feedback.removeAttribute("data-status");
        this.feedback.textContent = "";
        if (type === "myLocation") this.buttonMyLocation.dataset.loading = isSearching;
        else this.buttonSearch.dataset.loading = isSearching;
    }

    resetMap() {
        this.map.setZoom(this.defaultZoom);
        this.map.panTo(this.centreLatLng);
        this.list.groupByProv = true;
        this.stores.forEach(function (store) {
            store.distanceToLocation = null;
            store.listItem.querySelector('[data-location-list="distance"]').textContent = "";
        });
        this.showList();
    }

    setMapPosition(position, save = true) {
        if (!position) {
            if (!this.mapPosition.lat || !this.mapPosition.lng) return;
            position = this.mapPosition;
        }

        const parsedPos = {
            lat: typeof position.lat === "function" ? position.lat() : position.latitude || position.lat,
            lng: typeof position.lng === "function" ? position.lng() : position.longitude || position.lng
        };
        if (save) {
            this.mapPosition = parsedPos;

            // Update store location distances.
            this.stores.forEach(function (store) {
                const distanceToLocation = this.haversineCalculation(parsedPos, store);
                store.distanceToLocation = distanceToLocation;
                store.listItem.querySelector('[data-location-list="distance"]').textContent = `${store.distanceToLocation} km away`;
            }, this);
        }

        if (this.map.zoom < this.defaultZoomedIn) this.map.setZoom(this.defaultZoomedIn);
        this.map.panTo(parsedPos);
    }

    initSearch() {
        const geocoder = new google.maps.Geocoder();
        this.formSearch.addEventListener("submit", (event) => {
            event.preventDefault();
            this.selectStore(false);
            if (this.searching) return;

            // If the search value hasn't changed, don't run geocoder.
            const value = this.searchInput.value;
            if (value === "") return this.resetMap();
            if (value === this.prevSearch) return this.setMapPosition();

            this.setSearching(true);
            this.prevSearch = value;

            geocoder
                .geocode({
                    address: value,
                    componentRestrictions: { country: "ca" },
                    bounds: this.latLngBounds
                })
                .then(({ results }) => {
                    this.setSearching(false);

                    // If no results or is just Canada, reset the map.
                    const result = results ? results[0] : false;
                    if (!result || result.formatted_address === "Canada") {
                        // Show error message.
                        this.feedback.dataset.status = "error";
                        this.feedback.textContent = "No locations found. Please enter a city, province or postal code, or look for a location in the list.";
                        return this.resetMap();
                    }

                    this.setMapPosition(result.geometry.location);
                    this.list.groupByProv = false;
                    this.showList();
                })
                .catch((error) => {
                    console.error(`[google.maps.Geocoder] ${error}`);
                    this.setSearching(false);
                });
        });
    }

    useMyLocation() {
        if (this.searching) return;

        if (!navigator.geolocation) {
            this.feedback.dataset.status = "error";
            this.feedback.textContent = "Your browser does not support geolocation.";
            return this.buttonMyLocation.remove();
        }
        this.selectStore(false);
        this.setSearching(true, "myLocation");
        navigator.geolocation.getCurrentPosition(
            (position) => {
                this.setMapPosition(position.coords);
                this.prevSearch = false;
                this.setSearching(false, "myLocation");
                this.list.groupByProv = false;
                this.showList();
            },
            (error) => {
                this.setSearching(false, "myLocation");
                this.buttonMyLocation.remove();
                this.feedback.dataset.status = "error";
                if (error.code === 1) this.feedback.textContent = "You have denied access to your location. Please enter your location manually.";
                else this.feedback.textContent = "Unable to get your location. Please enter your location manually.";
                console.error(`[navigator.geolocation] ${error}`);
            }
        );
    }

    initStoreMarker(store) {
        const pin = new this.googleMaps.PinElement({
            background: store.brand === 'Urban Trail' ? "#d0debb" : "#D83A2C",
            borderColor: store.brand === 'Urban Trail' ? '#5d704a' : '#A73E35',
            glyphColor: store.brand === 'Urban Trail' ? '#5d704a' : '#A73E35',
        });

        const marker = new this.googleMaps.AdvancedMarkerElement({
            position: { lat: store.latitude, lng: store.longitude },
            title: store.name,
            content: pin.element
        });

        const storeMap = this;
        marker.addListener("spider_click", function (event) {
            storeMap.selectStore(store);
        });
        this.mapOms.addMarker(marker);
        store.marker = marker;
    }

    selectStore(store = false) {
        if (store === this.selectedStore) return;

        if (typeof store === "string") store = this.stores.find((s) => s.handle === store);

        if (this.selectedStore) {
            this.selectedStore.marker.zIndex = null;
        }

        this.selectedStore = store;
        let storePath = store ? `/${encodeURI(store.handle)}` : "";
        history.pushState({}, "", this.basePath + storePath);
        if (store) document.title = `${store.name} | ${this.documentTitle}`;
        else document.title = this.documentTitle;

        this.setStructuredData(store);

        if (!store) return this.toggleDetailsPanel(false);
        else this.toggleDetailsPanel(true, store);
    }

    setStructuredData(store) {
        // Remove any existing structured data.
        const existingScript = document.querySelector('script[type="application/ld+json"]');
        if (existingScript) existingScript.remove();

        if (!store) return;

        // Build structured data.
        const structuredData = {
            "@context": "https://schema.org",
            "@type": "Store",
            "address": {
                "@type": "PostalAddress",
                "streetAddress": store.address1 || "",
                "extendedAddress": store.address2 || "",
                "addressLocality": store.city || "",
                "addressRegion": store.province_code || "",
                "postalCode": store.zip || "",
                "addressCountry": store.country_code || "CA"
            },
            "name": store.name || "",
            "geo": {
                "@type": "GeoCoordinates",
                "latitude": store.latitude || "",
                "longitude": store.longitude || ""
            },
            "openingHoursSpecification": [],
            "telephone": store.phone || "",
            "url": window.location.href,
            "currenciesAccepted": "CAD",
            "paymentAccepted": "Cash, Credit Card"
        };

        // Add store hours.
        const convertHoursToTimeSchema = (time) => {
            if (!time) return null;
            const match = time.match(/(\d{1,2}):?(\d{2})?\s*(AM|PM)/i);
            if (!match) return null;

            let hours = parseInt(match[1]);
            const minutes = match[2] ? parseInt(match[2]) : 0;
            const period = match[3].toUpperCase();

            if (period === "PM" && hours < 12) hours += 12;
            if (period === "AM" && hours === 12) hours = 0;

            return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:00`;
        }

        const validSchemaDayOfWeek = [
            "Monday",
            "Tuesday",
            "Wednesday",
            "Thursday",
            "Friday",
            "Saturday",
            "Sunday"
        ];

        for (const item of store.store_hours || []) {
            // Convert "Monday~9:00 AM–5:00 PM" to structured data.
            const [day, hours] = item.split("~");
            if (!day || !hours) continue;

            if (!validSchemaDayOfWeek.includes(day)) continue;

            let [openTime, closeTime] = hours.split("–").map(t => t.trim());
            if (!openTime || !closeTime) continue;

            openTime = convertHoursToTimeSchema(openTime);
            closeTime = convertHoursToTimeSchema(closeTime);
            if (!openTime || !closeTime) continue;

            const openingHoursSpec = {
                "@type": "OpeningHoursSpecification",
                "dayOfWeek": `https://schema.org/${day}`,
                "closes": closeTime,
                "opens": openTime
            };

            structuredData.openingHoursSpecification.push(openingHoursSpec);
        }

        // Insert structured data.
        const script = document.createElement('script');
        script.type = 'application/ld+json';
        script.textContent = JSON.stringify(structuredData, null, 2);
        document.head.appendChild(script);
    }

    async toggleDetailsPanel(open, store = false) {
        const doToggleDetailsPanel = () => {
            if (open && store !== false) this.showStoreDetails(store);
            this.list.section.style.display = open ? "none" : null;
            this.details.section.style.display = open ? null : "none";
        }

        if (!document.startViewTransition) {
            doToggleDetailsPanel();
            if (open) this.details.section.scrollIntoView({ behavior: 'smooth' });
            return;
        }

        const transition = document.startViewTransition(async () => {;
            doToggleDetailsPanel();
        });

        try {
            await transition.finished;
        } finally {
            if (open) this.details.section.scrollIntoView({ behavior: 'smooth' });
        }
    }

    showStoreDetails(store) {
        // Set map position.
        this.setMapPosition(store, false);

        store.marker.zIndex = 9999;
        store.marker.content.style.setProperty("transition", "translate 300ms");
        store.marker.content.style.setProperty("translate", "0 0");
        store.marker.content.style.setProperty("translate", "0 -10px");

        setTimeout(() => {
            store.marker.content.style.setProperty("translate", "0");
        }, 300);

        // Insert store name.
        if (store.name) {
            this.details.name.textContent = store.name;
            this.details.nearbyName.textContent = store.name;
        } else {
            this.details.name.textContent = "Coming Soon";
            this.details.nearbyName.textContent = "";
        }

        // Insert store distance.
        if (store.distanceToLocation) this.details.distance.textContent = `${store.distanceToLocation} km away`;
        else this.details.distance.textContent = "";

        // Insert store address.
        if (store.address1) {
            this.details.buttonDirections.setAttribute("href", "https://www.google.com/maps/dir/?api=1&destination=" + encodeURIComponent(`${store.address1}, ${store.city}, ${store.province_code}, ${store.zip}`).replace(/%20/g, "+"));
            this.details.address.innerHTML = `${store.address1}<br/>${store.address2 ? `${store.address2}<br/>` : ""}${store.city}, ${store.province_code} ${store.zip}`;
        } else {
            this.details.buttonDirections.setAttribute("href", "#");
            this.details.address.innerHTML = "";
        }

        // Insert store phone.
        if (store.phone) {
            this.details.buttonPhone.setAttribute("href", "tel:" + encodeURIComponent(store.phone));
            this.details.phone.textContent = store.phone.replace(/(?:\+1)*(\d{3})(\d{3})(\d{4})/, "($1) $2-$3");
        } else {
            this.details.buttonPhone.setAttribute("href", "#");
            this.details.phone.textContent = "";
        }

        // Insert store notes.
        this.details.storeNotes.innerHTML = "";
        if (store.display_note) this.details.storeNotes.textContent = store.display_note;

        // Insert store hours.
        this.details.hours.innerHTML = "";
        if (store.store_hours && store.store_hours.length) {
            var storeHoursTemplate = this.querySelector("[data-location-hours='template']");

            store.store_hours.forEach(function (item) {
                var storeHour = item.split("~");
                var storeHourElement = storeHoursTemplate.content.cloneNode(true);
                storeHourElement.querySelector("[data-location-hours='day']").textContent = storeHour[0];
                storeHourElement.querySelector("[data-location-hours='times']").textContent = storeHour[1].replace(/\–/, " – ");
                this.details.hours.appendChild(storeHourElement);
            }, this);
        } else this.details.hours.innerHTML = "Call store for current store hours.";

        // Insert nearby stores.
        this.details.nearby.innerHTML = "";
        if (store.nearby) {
            var storeNearbyTemplate = document.querySelector("[data-location-nearby='template']");
            let count = 0;
            for (const item of store.nearby) {
                if (count > 2 || item.distance > 200) break;
                if (item.hidden) continue;
                count++;

                var storeNearbyElement = storeNearbyTemplate.content.cloneNode(true);

                var link = storeNearbyElement.querySelector("[data-location-nearby='link']");
                link.href = `${this.basePath}/${item.handle}`;
                link.textContent = item.name;
                link.addEventListener("click", (event) => {
                    event.preventDefault();
                    this.selectStore(item.handle);
                });

                storeNearbyElement.querySelector("[data-location-nearby='distance']").textContent = `${item.distance.toFixed(1)} km`;
                this.details.nearby.appendChild(storeNearbyElement);
            }
            if (count === 0) this.details.nearby.textContent = "Use the map to see other nearby stores.";
        } else {
            this.details.nearby.textContent = "Use the map to see other nearby stores.";
        }
    }

    initFilters() {
        Object.entries(this.filters).forEach(([key, filter]) => {
            filter.addEventListener("change", this.filterStores.bind(this));
        }, this);
    }

    filterStores() {
        this.selectStore();
        const filters = [];
        if (this.filters.quarks.checked) filters.push("Quarks");
        if (this.filters.urbanTrail.checked) filters.push("Urban Trail");

        this.stores.forEach((store) => {
            if (!filters.length || filters.includes(store.brand)) {
                store.marker.setMap(this.map);
                store.hidden = false;
            } else {
                store.marker.setMap(null);
                store.hidden = true;
            }

            store.nearby.forEach((nearby) => {
                if (!filters.length || filters.includes(nearby.brand)) {
                    nearby.hidden = false;
                } else {
                    nearby.hidden = true;
                }
            });
        });

        this.showList();
    }
}
customElements.define("store-locations", StoreLocations);
